import { render, staticRenderFns } from "./smTableExpand.vue?vue&type=template&id=064e7c1b&"
import script from "./smTableExpand.vue?vue&type=script&lang=js&"
export * from "./smTableExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports